import * as O from 'fp-ts/Option';
import type { Option } from 'fp-ts/Option';
import { atom } from 'jotai';

import { User } from '../domain/User';

export const userState = atom<Option<User>>(O.none);
